/**
 * Retry hold-down for blocked sign-in exchanges (#469 follow-up).
 *
 * A 403/429 on POST /api/auth/entra/callback with a non-app body is a network
 * security layer (in production, a Cloudflare zone rule — the API itself only
 * returns JSON errors) refusing the request before it reaches the app. An
 * office NATs everyone through one public IP, so immediate retries re-trip the
 * same per-IP rule for everyone behind it: blocked → retry → more requests →
 * the block persists. This module records when the next attempt is allowed so
 * LoginPage can hold the sign-in button instead of feeding the rule.
 */

export const AUTH_BLOCK_STORAGE_KEY = 'ss-auth-block-until';
export const DEFAULT_AUTH_BLOCK_COOLDOWN_MS = 60_000;

/** Record a blocked attempt; the next sign-in retry is held until now+ms. */
export function markAuthBlockedFor(ms: number, now: number = Date.now()): void {
  try {
    localStorage.setItem(AUTH_BLOCK_STORAGE_KEY, String(now + ms));
  } catch { /* storage unavailable — cooldown is best-effort */ }
}

/** Milliseconds until sign-in may be retried; 0 when no hold-down is active. */
export function authBlockRemaining(now: number = Date.now()): number {
  try {
    const raw = localStorage.getItem(AUTH_BLOCK_STORAGE_KEY);
    if (!raw) return 0;
    const until = Number(raw);
    if (!Number.isFinite(until)) return 0;
    return Math.max(0, until - now);
  } catch {
    return 0;
  }
}
